
const digest = 'c2b099c1abc805181efe2d1e2aa7004b11123951e13ecd6f230033cf72774a2a';
const classes = {"wrapper":"_wrapper_1f2kb_1","left":"_left_1f2kb_6","name":"_name_1f2kb_28","right":"_right_1f2kb_33","part":"_part_1f2kb_40","title":"_title_1f2kb_51"};
const css = `._wrapper_1f2kb_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
}
._wrapper_1f2kb_1 ._left_1f2kb_6 {
  min-width: 250px;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  border-right: 1px solid #ebedf3;
  font-size: 14px;
  color: #787878;
}
._wrapper_1f2kb_1 ._left_1f2kb_6 img {
  width: 120px;
  height: 120px;
  border-radius: 100%;
  object-fit: cover;
  border: 1px solid #f1f1f1;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}
._wrapper_1f2kb_1 ._left_1f2kb_6 ._name_1f2kb_28 {
  color: #2f61b2;
  font-size: 16px;
  font-weight: 600;
}
._wrapper_1f2kb_1 ._right_1f2kb_33 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 24px;
  flex: 1;
}
._wrapper_1f2kb_1 ._right_1f2kb_33 ._part_1f2kb_40 {
  background: #ffffff;
  border-radius: 15px;
  padding: 16px 24px;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1f2kb_1 ._right_1f2kb_33 ._part_1f2kb_40 ._title_1f2kb_51 {
  font-size: 16px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  